<div class="innerBanner" style="background-image: url('{{ bannerImage }}')">
  <!-- inner banner-->
  <div class="bannerText">
    <h1>{{ bannerInfo.bannerTitle }}</h1>
  </div>
</div>
<!-- <app-breadcrumb></app-breadcrumb> -->
<app-breadcrumb-row></app-breadcrumb-row>
<div class="instagramSection">
  <div class="container">
    <div class="contentPanel">
      <p [innerHTML]="bannerInfo.content"></p>
      <p>&nbsp;</p>
    </div>
  </div>
  <div class="container" *ngIf="!isGallery">
    <div class="row m-0">
      <div class="col-md-6 form-group">
        <div class="product-item slider-arrow">
          <a (click)="loadImages()">
            <div class="product-item-content">
              <div class="image">
                <img
                  src="../../assets/images/slider-video-1.avif"
                  alt="instagram Image"
                  class="product-image slider-image"
                />
              </div>
              <div class="title">
                <h3>{{ 'IMAGES' | translate }}</h3>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="col-md-6 form-group">
        <div class="product-item slider-arrow">
          <a (click)="loadVideos()">
            <div class="product-item-content">
              <div class="image">
                <img
                  src="../../assets/images/slider-video-1.avif"
                  alt="instagram Image"
                  class="product-image slider-image"
                />
              </div>
              <div class="title">
                <h3>{{ 'VIDEOS' | translate }} <i class="fa fa-play-circle"></i></h3>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="subscribePanel" *ngIf="isGallery">
    <div id="dvImages">
      <p-galleria
        [(value)]="images"
        [(visible)]="displayCustom"
        [(activeIndex)]="activeIndex"
        [responsiveOptions]="responsiveOptions"
        [containerStyle]="{ 'max-width': '850px' }"
        [numVisible]="7"
        [circular]="true"
        [fullScreen]="true"
        [showItemNavigators]="true"
        [showThumbnails]="false"
        [baseZIndex]="100000"
      >
        <ng-template pTemplate="item" let-item>
          <img [src]="item.previewImageSrc" class="gallery-image" />
        </ng-template>
      </p-galleria>
      <div *ngIf="images" class="p-grid">
        <div *ngFor="let image of images; let index = index" class="p-col-10 galleryImages" key="index">
          <img [src]="image.thumbnailImageSrc" [alt]="image.alt" style="cursor: pointer" (click)="imageClick(index)" />
        </div>
      </div>
    </div>
    <div id="dvVideos">
      <p-galleria
        [(value)]="videos"
        [(visible)]="displayVideoCustom"
        [(activeIndex)]="activeIndex"
        [responsiveOptions]="responsiveOptions"
        [containerStyle]="{ 'max-width': '850px' }"
        [numVisible]="7"
        [circular]="true"
        [fullScreen]="true"
        [showItemNavigators]="true"
        [showThumbnails]="false"
        [baseZIndex]="100000"
      >
        <ng-template pTemplate="item" let-item>
          <video width="800" id="video1" height="600" controls [src]="item.sopVideo" [autoplay]="true"></video>
        </ng-template>
        <ng-template pTemplate="thumbnail" let-item>
          <div class="p-grid p-nogutter p-justify-center">
            <img [src]="item.thumbnailImageSrc" style="display: block" />
          </div>
        </ng-template>
      </p-galleria>
      <div *ngIf="videos" class="p-grid">
        <div *ngFor="let videoData of videos; let index = index" class="p-col-10 galleryVideos" key="index">
          <img
            [src]="videoData.thumbnailImageSrc"
            [alt]="videoData.alt"
            style="cursor: pointer"
            (click)="playVideo(index)"
          />
          <i class="fa fa-play-circle"></i>
        </div>
      </div>
    </div>
  </div>
</div>
